import { Injectable } from '@angular/core';

import { STATES, CITIES } from './state-city.constants';

/**
 * State City Provider
 */
@Injectable({ providedIn: 'root' })
export class StateCityService {
  /**
   * States of brazil
   */
  public states = STATES;

  /**
   * Cities of brazil.
   */
  public cities = CITIES;

  /**
   * Sort by string.
   */
  public compare = (a, b) => {
    if (a.nome < b.nome) {
      return -1;
    }
    if (a.nome > b.nome) {
      return 1;
    }
    return 0;
  };

  /**
   * @ignore
   */

  /**
   * Get the list of states
   */
  getStates() {
    return this.states;
  }

  /**
   * Get the list of cities
   */
  getCities() {
    return this.cities.sort(this.compare);
  }

  /**
   * Get the list of cities
   */
  getCitiesFromState(stateId: number) {
    return this.cities.filter(city => city.estado === stateId);
  }

  /**
   * Get specific state from acronym
   */
  getStatesByAcronym(acronym: string) {
    return this.states.find(state => state.sigla === acronym);
  }
}
